import { types } from "mobx-state-tree";
import type { Instance, SnapshotIn, SnapshotOut } from "mobx-state-tree";

export interface TimeslotInstance extends Instance<typeof Timeslot> {}
export interface TimeslotSnapshotIn extends SnapshotIn<typeof Timeslot> {}
export interface TimeslotSnapshotOut extends SnapshotOut<typeof Timeslot> {}

export const Practitioner = types.model("Practitioner", {
  id: types.string,
  name: types.string,
});

export const Timeslot = types.model("User", {
  id: types.identifier,
  startUtc: types.string,
  endUtc: types.string,
  practitioner: Practitioner,
});
